export default __webpack_public_path__ + "static/media/pdf-icon.4d434ce3.jpeg";